import React from 'react';
import { useToast } from '../../contexts/ToastContext';

const TONE = {
  info:    { border: '#4a3d28', bg: 'rgba(20,32,56,0.95)',  fg: '#f0e6d0' },
  success: { border: '#5cb870', bg: 'rgba(20,40,28,0.95)',  fg: '#a8e8b8' },
  warn:    { border: '#d4943a', bg: 'rgba(58,42,16,0.95)',  fg: '#f0c870' },
  danger:  { border: '#e07070', bg: 'rgba(56,20,20,0.95)',  fg: '#f0a8a8' },
};

export default function ToastViewport() {
  const { toasts, dismissToast } = useToast();
  if (toasts.length === 0) return null;
  return (
    <div style={styles.viewport} aria-live="polite">
      {toasts.map((t) => {
        const tone = TONE[t.type] || TONE.info;
        return (
          <div
            key={t.id}
            style={{ ...styles.toast, background: tone.bg, borderColor: tone.border, color: tone.fg }}
            role="status"
          >
            {t.icon && <span style={styles.icon}>{t.icon}</span>}
            <span style={styles.message}>{t.message}</span>
            <button
              style={{ ...styles.closeBtn, color: tone.fg }}
              onClick={() => dismissToast(t.id)}
              aria-label="Dismiss"
            >✕</button>
          </div>
        );
      })}
    </div>
  );
}

const styles = {
  viewport: {
    position: 'fixed',
    top: 12,
    right: 12,
    zIndex: 9999,
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
    pointerEvents: 'none',
    maxWidth: 'min(360px, calc(100vw - 24px))',
  },
  toast: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    padding: '8px 10px 8px 12px',
    border: '1px solid',
    borderRadius: 6,
    fontSize: 13,
    fontWeight: 600,
    boxShadow: '0 8px 24px rgba(0,0,0,0.55)',
    backdropFilter: 'blur(6px)',
    pointerEvents: 'auto',
    fontFamily: "'Press Start 2P', 'Palatino Linotype', monospace",
    animation: 'toastSlideIn 200ms ease-out',
  },
  icon: { fontSize: 16, lineHeight: 1 },
  message: { flex: 1, lineHeight: 1.3 },
  closeBtn: {
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    fontSize: 12,
    fontWeight: 700,
    opacity: 0.6,
    padding: '2px 4px',
    borderRadius: 3,
    lineHeight: 1,
  },
};
